import { DynamicQueryEvent, DynamicQueryEventTypes } from './dynamic-query-events.factory';
import { Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { DynamicQueryObservable } from './dynamic-query-observable.model';

@Injectable({
  providedIn: 'root'
})
export class DynamicQueryDecoratorService {
  private doneFilter;
  private insertedFilter;
  private updatedFilter;
  private deletedFilter;

  constructor() {
    this.doneFilter = this._eventFilter(DynamicQueryEventTypes.DONE);
    this.insertedFilter = this._eventFilter(DynamicQueryEventTypes.INSERTED);
    this.updatedFilter = this._eventFilter(DynamicQueryEventTypes.UPDATED);
    this.deletedFilter = this._eventFilter(DynamicQueryEventTypes.DELETED);
  }

  private _eventFilter(eventName) {
    return function messageEventFilter(message) {
      return message.event === eventName;
    };
  }

  public create<T>(observable: DynamicQueryObservable<any>, modelMapper: (ev: DynamicQueryEvent) => T): DynamicQueryObservable<T> {
    if (!observable) {
      throw new Error('Missing observable parameter');
    }
    if (!modelMapper) {
      throw new Error('Missing modelMapper parameter');
    }

    observable.done = () => observable.pipe(filter(this.doneFilter), map(modelMapper));
    observable.inserted = () => observable.pipe(filter(this.insertedFilter), map(modelMapper));
    observable.deleted = () => observable.pipe(filter(this.deletedFilter), map(modelMapper));
    observable.updated = () => observable.pipe(filter(this.updatedFilter), map(modelMapper));

    return <DynamicQueryObservable<T>>observable;
  }
}
